
import { useState, useEffect } from 'react';
import Navbar from '@/components/layout/Navbar';
import HeroSection from '@/components/home/HeroSection';
import ServicesSection from '@/components/home/ServicesSection';
// import FeaturedShopsSection from '@/components/home/FeaturedShopsSection';
import HowItWorksSection from '@/components/home/HowItWorksSection';
import BenefitsSection from '@/components/home/BenefitsSection';
import CTASection from '@/components/home/CTASection';
import Footer from '@/components/layout/Footer';

const HomePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`min-h-screen bg-white ${isLoaded ? 'animate-fade-in' : 'opacity-0'}`}>
      <Navbar />
      
      {/* Hero Section */}
      <HeroSection />
      
      {/* How It Works Section */}
      <div className="py-12 md:py-16 lg:py-20">
        <HowItWorksSection />
      </div>
      
      {/* Services Section */}
      <div className="py-12 md:py-16 lg:py-20">
        <ServicesSection />
      </div>
      
      {/* Benefits Section */}
      <div className="py-12 md:py-16 lg:py-20">
        <BenefitsSection />
      </div>
      
      {/* CTA Section */}
      <div className="py-12 md:py-16 lg:py-20">
        <CTASection />
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage;
